import moment from "moment";

function count_keys_start_with(obj, key) {
  let count = 0;
  for (let k in obj) {
    if (k.startsWith(key)) {
      count++;
    }
  }
  return count;
}
function get_keys_start_with(obj, key) {
  let keys = [];
  for (let k in obj) {
    if (k.startsWith(key)) {
      keys.push(k);
    }
  }
  return keys;
}
function multipy_keys_start_with(root, obj, key) {
  let product = 0;
  if (obj.calc_type == "period") {
    let days = 0;
    days = moment(obj.period[1]).diff(moment(obj.period[0]), "days", true);
    product = days;
  }
  if (obj.calc_type !== "percentage") {
    for (let k in obj) {
      if (k.startsWith(key)) {
        if (product == 0) {
          product = parseFloat(obj[k]);
        } else {
          product *= parseFloat(obj[k]);
        }
      }
    }
  }
  if (obj.calc_type == "percentage") {
    let base_amount = root.reduce((acc, cur) => {
      if (
        cur.calc_type != "percentage" &&
        obj.debit_credit != cur.debit_credit
      ) {
        acc += multipy_keys_start_with(root, cur, key);
      }
      return acc;
    }, 0);
    let rate = 0;
    for (let k in obj) {
      if (k.startsWith(key)) {
        rate = parseFloat(obj[k]);
      }
    }
    product = base_amount * parseFloat(rate / 100);
  }
  return product;
}
function sum_breakdown(arr, key, debit_credit) {
  let sum_product = 0;
  arr.forEach((bd) => {
    if (bd.debit_credit == debit_credit) {
      sum_product += multipy_keys_start_with(arr, bd, key);
    }
  });
  return sum_product;
}

/////////////////////////////////
function get_item_template(key) {
  let i = this.template()[key];
  return i;
}
function if_period_based_item_exist(arr) {
  let flag = false;
  arr.forEach((a) => {
    if (a.calc_type == "period") {
      flag = true;
    }
  });
  return flag;
}
function total_perid_in_days(arr) {
  return arr.reduce((acc, cv) => {
    if (cv.calc_type == "period") {
      acc += cv.period
        ? moment(cv.period[1]).diff(moment(cv.period[0]), "days", true)
        : 0;
    }
    return acc;
  }, 0);
}
function has_freight_quantity(ac) {
  let a = ac.accounts.find((act) => act.account_name == "Charterer");
  let flag = false;
  a.sub_accounts.forEach((sub) => {
    if (sub.hasOwnProperty("is_freight")) {
      flag = true;
    }
  });
  return flag;
}
function get_freight_quantity(ac) {
  let a = ac.accounts.find((act) => act.account_name == "Charterer");
  let tons = 0;
  a.sub_accounts.forEach((sub) => {
    if (sub.hasOwnProperty("is_freight")) {
      sub.breakdown.forEach((bd) => {
        if (bd.calc_type == "two") {
          tons += parseFloat(bd.value_TONS);
        }
      });
    }
  });
  return tons;
}
function get_total(ac, debit_credit) {
  let total = 0;
  ac.accounts.forEach((ac) => {
    ac.sub_accounts.forEach((sub) => {
      total += sum_breakdown(sub.breakdown, "value", debit_credit);
    });
  });
  return total;
}
function get_perf_freight(ac, sub) {
  let tons = [];
  let pl = get_total(ac, "debit") - get_total(ac, "credit");
  sub.breakdown.forEach((bd) => {
    if (bd.calc_type == "two") {
      tons.push(bd.value_TONS);
    }
  });
  let share_pl_per_ton = tons.map((t) => {
    let total_tons = tons.reduce((acc, cv) => {
      return acc + parseFloat(cv);
    }, 0);
    return (pl * (parseFloat(t) / parseFloat(total_tons))) / parseFloat(t);
  });
  let performance_freight = [];
  sub.breakdown
    .filter((brd) => brd.calc_type == "two")
    .forEach((bd, bd_pos) => {
      performance_freight.push(
        parseFloat(bd.value_FREIGHT) - share_pl_per_ton[bd_pos]
      );
    });
  return performance_freight;
}
function get_unsettled_total(ac, debit_credit) {
  let total = 0;
  ac.accounts.forEach((ac) => {
    ac.sub_accounts.forEach((sub) => {
      sub.breakdown.forEach((bd) => {
        if (bd.is_settled == false && bd.debit_credit == debit_credit) {
          total += multipy_keys_start_with(sub.breakdown, bd, "value");
        }
      });
    });
  });
  return total;
}
function sanitize_account(record) {
  let obj = JSON.parse(JSON.stringify(record));
  delete obj.id;
  delete obj.creator;
  delete obj.lasteditor;
  delete obj.lastupdate;
  for (let k in obj) {
    if (typeof obj[k] == "string") {
      obj[k] = "";
    }
    if (typeof obj[k] == "number") {
      obj[k] = 0;
    }
    if (typeof obj[k] == "object" && obj[k].length == 2) {
      obj[k] = ["", ""];
    }
  }
  obj.accounts.forEach((ac) => {
    ac.sub_accounts.forEach((sub) => {
      sub.breakdown.forEach((bd) => {
        bd.is_settled = false;
        for (let k in bd) {
          if (k.startsWith("value")) {
            bd[k] = "0";
          }
          if (k == "period") {
            bd.period = ["", ""];
          }
        }
      });
    });
  });
  return obj;
}

export {
  sanitize_account,
  count_keys_start_with,
  get_keys_start_with,
  multipy_keys_start_with,
  sum_breakdown,
  get_item_template,
  if_period_based_item_exist,
  total_perid_in_days,
  has_freight_quantity,
  get_freight_quantity,
  get_total,
  get_perf_freight,
  get_unsettled_total,
};
